import { render, staticRenderFns } from "./Plot.vue?vue&type=template&id=18d166bd&scoped=true&"
import script from "./Plot.vue?vue&type=script&lang=js&"
export * from "./Plot.vue?vue&type=script&lang=js&"
import style0 from "./Plot.vue?vue&type=style&index=0&id=18d166bd&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d166bd",
  null
  
)

export default component.exports